/*
 * @Descripttion: 
 * @version: 1.0
 * @Author: zhanmei
 * @Date: 2020-07-31 15:16:47
 * @LastEditors: zhanmei
 * @LastEditTime: 2020-10-26 13:15:07
 */
/**
 * Created by 58 on 2017/12/4.
 */
module.exports = {
  rd: {
    WOS_APP_ID: 'JLkLFeDcBaJPq',          // 去wos申请的appid，eg:EGfbAZyXwVEhG 链接：http://wos.58corp.com/app/userlist
    WOS_URL: 'https://testv3.58v5.cn', // 测试环境域名
    WOS_CDN_URL: 'https://testv3.58v5.cn',
    WOS_SECRECT_ID: 'KUYDnaVA2ohJWnf2ASwVXD7Wt2ixi73d',
    WOS_SECRECT_KEY: 'FJKMLjdn7OSue3YFYmxcgtsSg4xlaDqR',
    IS_COVER: 1       // 0:覆盖  1：不覆盖*/
  },
  qa: {
    WOS_APP_ID: 'JLkLFeDcBaJPq',          // 去wos申请的appid，eg:EGfbAZyXwVEhG 链接：http://wos.58corp.com/app/userlist
    WOS_URL: 'https://testv3.58v5.cn', // 测试环境域名
    WOS_CDN_URL: 'https://testv3.58v5.cn',
    WOS_SECRECT_ID: 'KUYDnaVA2ohJWnf2ASwVXD7Wt2ixi73d',
    WOS_SECRECT_KEY: 'FJKMLjdn7OSue3YFYmxcgtsSg4xlaDqR',
    IS_COVER: 1       // 0:覆盖  1：不覆盖*/
  },
  integrate: {
    WOS_APP_ID: 'uVsRqPouVAC',          // 去wos申请的appid，eg:EGfbAZyXwVEhG 链接：http://wos.58corp.com/app/userlist
    WOS_CLIENT_APP_ID:'vBtSrQpOnvx',
    WOS_CLIENT_URL: 'https://jcwos.58.com',   
    WOS_URL: 'https://wos.58.com',                   // 线上环境域名
    WOS_CDN_URL: 'https://wos.58cdn.com.cn',
    WOS_SECRECT_ID: 'KUYDnaVA2ohJWnf2ASwVXD7Wt2ixi73d',
    WOS_SECRECT_KEY: 'FJKMLjdn7OSue3YFYmxcgtsSg4xlaDqR',
    IS_COVER: 1       // 0:覆盖  1：不覆盖
  },
  online: {
    WOS_APP_ID: 'ZAbwVuTsRqZh',          // 去wos申请的appid，eg:EGfbAZyXwVEhG 链接：http://wos.58corp.com/app/userlist
    WOS_CLIENT_APP_ID:'pQnMlKjIpQt',
    WOS_URL: 'https://wos2.58.com',                   // 线上环境域名
    WOS_CLIENT_URL: 'https://wos.58.com',                   // 线上环境域名
    WOS_CDN_URL: 'https://wos2.58cdn.com.cn',
    WOS_CLIENT_CDN_URL: 'https://wos.58cdn.com.cn',
    WOS_SECRECT_ID: '6AFmpLoXKlqBlZaRB89WEXthIGfAoDfk',
    WOS_SECRECT_KEY: 'xvM3yVSNU15ySqn49sNLG6FaqvWwLilx',
    IS_COVER: 1       // 0:覆盖  1：不覆盖
  }
};